import React from 'react'
import './services.css'

const Services = () => {
  return (
    <section id='services'></section>
  )
}

export default Services